import * as THREE from 'three'
import gsap from 'gsap' //tweening

const TILT_BACK_THRESHOLD = 0.05;
const FLIP_Y_QUATERNION = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI);


function highLiftCard(card, zTarget) {

    const liftDurationFirst = 1;
    const rotationDurationFirst = 0.1;
    const rotationDurationSecond = 0.6;
    const tilt = -0.45;
    // const tilt = THREE.MathUtils.randFloat(-0.2, -0.45);

    const tl = gsap.timeline({ defaults: { overwrite: "auto" } });
    // MOVE
    tl.to(card.wrapper.position, {
        duration: liftDurationFirst,
        // ease: "power1.out",
        ease: "elastic.out(0.8, 0.8)",
        z: zTarget,
    }, 0);

    // ROTATE
    tl.to(card.model.rotation, {
        duration: rotationDurationFirst,
        ease: "power1.in",
        x: tilt,
    }, 0);

    tl.to(card.model.rotation, {
        duration: rotationDurationSecond,
        ease: "elastic.out(1, 0.8)",
        x: 0,
    }, liftDurationFirst - liftDurationFirst * 0.75); // 0.75 is dependend on values in elastic.out as it skews the timing strogly
}



function liftCard(card, zTarget, duration = 0.65) {
    gsap.to(card.wrapper.position, {
        duration: duration,
        // ease: "power1.in",
        ease: "elastic.out(1, 0.75)",
        z: zTarget,
        overwrite: "auto",
    });
}

function liftAndDropCard(card, zTarget, durationFirst = 0.08, durationSecond = 0.28, zOvershoot = 0.65) {
    // Random subtle tilt so each lift feels slightly different
    // const tilt = THREE.MathUtils.randFloat(0, 0.4);
    const tilt = 0.4;
    const tl = gsap.timeline({ defaults: { overwrite: "auto" } });

    // lift (position + rotate) starting at timeline 0
    tl.to(card.wrapper.position, {
        duration: durationFirst,
        // ease: "power1.inOut",
        ease: "none",
        z: zTarget + zOvershoot,
    }, 0);

    tl.to(card.model.rotation, {
        duration: durationFirst,
        // ease: "power1.inOut",
        ease: "none",
        x: tilt,
    }, 0);

    // settle back starting at durationFirst so timings are explicit
    tl.to(card.wrapper.position, {
        duration: durationSecond,
        // ease: "power1.out",
        ease: "none",
        z: zTarget,
    }, durationFirst);

    tl.to(card.model.rotation, {
        duration: durationSecond,
        // ease: "power1.out",
        ease: "none",
        x: 0,
    }, durationFirst);
}

function dropFromHighlifted(card, zTarget) {
    const durationDrop = 0.6;
    const durationRotationFirst = durationDrop * 0.4;
    const durationRotationSecond = (durationDrop - durationRotationFirst) * 0.8;
    // const tilt = THREE.MathUtils.randFloat(0, 0.4);
    // const tilt = 0.3;
    const tilt = 0.3;

    const tl = gsap.timeline({ defaults: { overwrite: "auto" } });
    tl.to(card.wrapper.position, {
        duration: durationDrop,
        ease: "power1.out",
        z: zTarget,
    }, 0);

    tl.to(card.model.rotation, {
        duration: durationRotationFirst,
        ease: "power1.out",
        // ease: "none",
        x: tilt,
    }, 0);

    tl.to(card.model.rotation, {
        duration: durationRotationSecond,
        ease: "power1.in",
        // ease: "none",
        x: 0,
    }, durationRotationFirst);
}

function dropCard(card, zTarget) {
    gsap.to(card.wrapper.position, {
        duration: 0.3,
        ease: "power1.out",
        // ease: "none",
        z: zTarget,
        overwrite: "auto",
        onStart: () => fastReverseTilt(card.model)
    });
}

function fastReverseTilt(object) {
    gsap.to(object.rotation, {
        duration: 0.1,
        // ease: "power1.in",
        ease: "none",
        x: 0,
        y: 0,
        overwrite: "auto",
        // overwrite: true,
    });
}

function reverseTilt(object) {
    gsap.to(object.rotation, {
        duration: 0.3,
        // ease: "power1.in",
        ease: "none",
        x: 0,
        y: 0,
        overwrite: "auto",
    });
}

function dragCard(card, targetPosition, rotationStrength) {
    // move wrapper, but don't rotate it
    gsap.to(card.wrapper.position, {
        duration: 0.125,
        ease: "none",
        x: targetPosition.x,
        y: targetPosition.y
    });

    // Note: We need to reverse the rotation direction, because the wrapper might be rotated too
    const rotationX = card.isFaceUp ? rotationStrength.y : -rotationStrength.y;
    const rotationY = card.isFaceUp ? rotationStrength.x : rotationStrength.x;
    gsap.to(card.model.rotation, {
        duration: 0.3,
        // ease: "power1.in",
        ease: "none",
        x: rotationX,
        y: rotationY,
        onComplete: () => {
            if (!gsap.isTweening(card.model.rotation)) {
                reverseTilt(card.model);
            }
            if (Math.abs(rotationStrength.x) < TILT_BACK_THRESHOLD && Math.abs(rotationStrength.y) < TILT_BACK_THRESHOLD) {
                reverseTilt(card.model);
            }
        }
    });
}

function flipCard(card, faceUp) {
    if (typeof faceUp !== 'boolean')
        throw new Error(`Invalid faceUp ${faceUp}, expected boolean`);

    const yRad = THREE.MathUtils.degToRad(faceUp ? 180 : 0);
    gsap.to(card.wrapper.rotation, {
        duration: 0.15,
        ease: "power1.in",
        y: yRad,
        overwrite: "auto",
    });
}

function flipCardQuaternion(card, faceUp, onComplete, durationFlip = 0.15) {
    // Always target absolute face-up or face-down quaternion, so rapid flips converge cleanly.
    const targetQuaternion = faceUp
        ? FLIP_Y_QUATERNION.clone()
        : new THREE.Quaternion(); // identity = face down
    // Kill any in-flight flip tween on this wrapper to prevent accumulation
    gsap.killTweensOf(card.wrapper, "quaternion");
    rotateQuaternionTo(card.wrapper.quaternion, targetQuaternion, "power1.inOut", durationFlip, onComplete);
}

function objectLookAt(object, targetPosition, flipAxisVector, duration) {
    duration = duration || 0.3;
    const rotationMatrix = new THREE.Matrix4();
    const targetQuaternion = new THREE.Quaternion();
    rotationMatrix.lookAt(object.position, targetPosition, object.up);
    targetQuaternion.setFromRotationMatrix(rotationMatrix);
    if (flipAxisVector) {
        targetQuaternion.multiply(new THREE.Quaternion().setFromAxisAngle(flipAxisVector, Math.PI));
    }
    rotateQuaternionTo(object.quaternion, targetQuaternion, "power1.in", duration);
}

function rotateQuaternionTo(quaternion, targetQuaternion, ease, duration, onComplete) {
    gsap.to({}, {
        duration: duration,
        ease: ease,
        onUpdate: function () {
            quaternion.slerp(targetQuaternion, this.progress());
        },
        onComplete: () => {
            quaternion.copy(targetQuaternion);
            if (onComplete) onComplete();
        }
    });
}

function focusCardToCamera(card, vignette, camera, distanceFromCamera, onComplete) {
    distanceFromCamera = distanceFromCamera || 1.6;
    const targetPosition = new THREE.Vector3(0, 0, -distanceFromCamera);
    targetPosition.applyMatrix4(camera.instance.matrixWorld);

    gsap.to(card.wrapper.position, {
        duration: 0.4,
        ease: "power1.in",
        x: targetPosition.x,
        y: targetPosition.y,
        z: targetPosition.z,
        overwrite: "auto",
        onUpdate: () => {
            objectLookAt(card.wrapper, camera.instance.position, card.isFaceUp ? null : new THREE.Vector3(0, 1, 0), 0);
        },
        onComplete: () => {
            if (onComplete) onComplete();
        }
    });
    gsap.to(vignette, {
        sharpness: 1.0,
        duration: 1,
        ease: "power1.in",
        overwrite: `auto`,
    });
    gsap.to(vignette, {
        // baseAlpha: 1.35,
        baseAlpha: 1.04,
        duration: 0.8,
        ease: "power1.in",
        overwrite: `auto`,
    });
}

function defocusCard(card, vignette, targetPosition, onComplete) {
    rotateQuaternionTo(card.wrapper.quaternion, card.getFaceQuaternion(), "power1.out", 0.3);
    gsap.to(card.wrapper.position, {
        duration: 0.4,
        ease: "power1.out",
        x: targetPosition.x,
        y: targetPosition.y,
        z: targetPosition.z,
        onComplete: () => {
            if (onComplete) onComplete();
        }
    });

    const sharpnessTarget = vignette.sharpnessInitial ?? vignette.sharpness;
    const baseAlphaTarget = vignette.baseAlphaInitial ?? vignette.baseAlpha;

    gsap.to(vignette, {
        sharpness: sharpnessTarget,
        duration: 0.4,
        delay: 0.11,
        ease: "power1.out",
        overwrite: `auto`,
    });
    gsap.to(vignette, {
        baseAlpha: baseAlphaTarget,
        duration: 0.4,
        delay: 0.11,
        ease: "power1.out",
        overwrite: `auto`,
    });
}

function fadeHighlight(card, targetValue, speed) {
    card.withMaterials((material) => {
        gsap.to(material, {
            duration: speed,
            ease: "power1.in",
            emissiveIntensity: targetValue
        });
    });
}

function fadeLight(light, targetValue) {
    gsap.to(light, {
        duration: 1,
        ease: "power1.in",
        intensity: targetValue,
    });
}

const FOCUS_TILT_MAX = 0.45;

function focusTilt(card, rotX, rotY) {
    gsap.to(card.model.rotation, {
        duration: 0.25,
        ease: "power1.out",
        x: THREE.MathUtils.clamp(rotX, -FOCUS_TILT_MAX, FOCUS_TILT_MAX),
        y: THREE.MathUtils.clamp(rotY, -FOCUS_TILT_MAX, FOCUS_TILT_MAX),
        overwrite: "auto",
    });
}

function resetFocusTilt(card) {
    gsap.to(card.model.rotation, {
        duration: 0.2,
        ease: "power1.out",
        x: 0,
        y: 0,
        overwrite: "auto",
    });
}

export default {
    liftCard,
    liftAndDropCard,
    highLiftCard,
    dropCard,
    dropFromHighlifted,
    dragCard,
    flipCard,
    flipCardQuaternion,
    focusCardToCamera,
    defocusCard,
    fadeHighlight,
    fadeLight,
    focusTilt,
    resetFocusTilt,
    TILT_BACK_THRESHOLD,
    FLIP_Y_QUATERNION,
};
